/**
 * Pages retirées du produit, dont le code reste en place.
 *
 * Un drapeau plutôt qu'une suppression : les simulations déjà lancées avec ces
 * workflows doivent continuer d'afficher leurs résultats, et rallumer une page
 * pour une démonstration ne doit pas demander de retrouver du code supprimé.
 *
 * Même intention que FICHES_HISTORIQUES_VISIBLES dans LaunchSimulationPage.
 */

/**
 * « Custom Geometry CFD » — la page où un client déposait un STL et réglait une
 * seule vitesse.
 *
 * Retirée le 12 septembre 2026. Trois raisons, dans cet ordre :
 *
 *  - Elle rendait une **analyse directe**, pas une optimisation. C'est ce que
 *    fait n'importe quel outil CFD ; notre différence est ailleurs.
 *  - Elle ne permettait pas de poser une vraie question : une vitesse, et rien
 *    d'autre. Ni portance visée, ni contrainte, ni budget.
 *  - Mailler un STL arbitraire sans supervision est fragile. Une géométrie non
 *    étanche ou à la mauvaise échelle rend un résultat plausible et faux —
 *    vendre un chiffre faux coûte plus cher que ne rien vendre.
 *
 * Ce qui la remplace : une entrée `file` dans les cases qui tournent déjà sur
 * blockMesh + snappyHexMesh (`jbc_hull`, `nrel6`). Le client y apporte sa
 * géométrie *dans* un case — recette de maillage éprouvée, bornes validées côté
 * serveur, budget, diagnostic, et une optimisation au bout.
 *
 * Le workflow `custom_geometry` reste en service côté backend et dans l'image de
 * calcul : seule la porte d'entrée est fermée.
 */
export const PAGE_GEOMETRIE_LIBRE_VISIBLE = false;
